import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { TableCell } from 'smartsuite-ui';
import { getExternalLinkParameterForAdvancedSearch } from 'smartsuite-advanced-search-app';
import { buildQueryConfiguration } from './advancedSearchLinkUtils';
import { getNonApiUri } from '../../../utils/getUri';

export default function AdvancedSearchLinkCell({
    argumentConfigs,
    dataRow,
    filterValues,
    pathName,
    timeAndPrecision,
    whereClauses,
    value,
}) {
    const advancedSearchTranslation = useTranslation('advancedSearch');
    const predicateLabels = advancedSearchTranslation.t('predicateLabels', {
        returnObjects: true,
    });

    const onClick = async () => {
        const queryConfiguration = buildQueryConfiguration(
            timeAndPrecision,
            filterValues,
            whereClauses,
            dataRow,
            argumentConfigs,
            predicateLabels
        );

        const externalLinkParameter = await getExternalLinkParameterForAdvancedSearch(
            queryConfiguration
        );

        window.open(
            `${window.location.origin}${getNonApiUri(
                `${pathName}?${externalLinkParameter}`
            )}`
        );
    };

    /* eslint-disable jsx-a11y/anchor-is-valid */
    return (
        <TableCell>
            <a onClick={onClick}>{value}</a>
        </TableCell>
    );
    /* eslint-enable jsx-a11y/anchor-is-valid */
}

AdvancedSearchLinkCell.propTypes = {
    argumentConfigs: PropTypes.instanceOf(Array).isRequired,
    dataRow: PropTypes.instanceOf(Object).isRequired,
    filterValues: PropTypes.instanceOf(Object).isRequired,
    pathName: PropTypes.string.isRequired,
    timeAndPrecision: PropTypes.instanceOf(Object).isRequired,
    whereClauses: PropTypes.instanceOf(Array).isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
